// JsFromRoutes CacheKey 2c398575b21ba12d79baf7c2a1c4fce6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const futurePlanResponses = {
  create: definePathHelper("post", "/future_plans"),
  new: definePathHelper("get", "/future_plans/new"),
};
